import React from 'react';
import * as Yup from "yup";
import { Paper, withStyles } from '@material-ui/core';
import CPUForm from './CPUForm'
import { BackButton, hasPermission, parseURL } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/cpuActions";
import History from "../../../History";
const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const CPUCreate = props => {
    const { permissions, activeCustomer, translations, classes } = props;
    let searchParams = parseURL(window.location.search);
    const handleSubmit = async data => {
        data['ProductID'] = searchParams.productID;
        let result = await props.onCreateCPU({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        ComponentType: "cpu",
        Vendor: "",
        Version: '',
        ComponentModel: '',
        SerialNumber: '',
        BusInfo: '',
        Capacity: 0,
        Clock: 0,
        Size: 0,
        Slot: '',
        Width: 0,
        Generation: '',
        ShortName: '',
        Description: ''
    }

    let formSettings = {
        Validation: {
            ComponentType: Yup.string().required("Required"),
            Vendor: Yup.string().required("Required"),
            Version: Yup.string().required("Required"),
            ComponentModel: Yup.string().required("Required"),
            SerialNumber: Yup.string().required("Required"),
            BusInfo: Yup.string().required("Required"),
            Capacity: Yup.number().required("Required"),
            Clock: Yup.number().required("Required"),
            Size: Yup.number().required("Required"),
            Slot: Yup.string().required("Required"),
            Width: Yup.number().required("Required"),
            ShortName: Yup.string().required("Required"),
            Generation: Yup.string().required("Required"),
        },
        FormTitle: translations['create_cpu_component'] || 'Create cpu component',
        ButtonSubmit: hasPermission(permissions, "component_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <CPUForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
            ></CPUForm>
        </Paper>
    )
}
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateCPU: cpu => dispatch(actions.createCPU(cpu)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CPUCreate));
